import { APIProvider, Map } from '@vis.gl/react-google-maps'
import { memo, useEffect, useRef, useState } from 'react'

import { GOOGLE_MAPS_API_KEY } from '../../configs/environment.js'
import { useAuth } from '../Shared/Contexts/AuthContext.jsx'
import { useGlobalContext } from '../Shared/Contexts/GlobalContext.jsx'
import Markers from './Markers.jsx'

let markersCache = { signature: null, data: [] }

const FrontMap = () => {
  const {
    map: { center, zoom },
    useFetchMarkers,
    devicesFilters: filters
  } = useGlobalContext()

  const {
    authState: { isAuthenticated },
    currentOrganizationKey
  } = useAuth()

  const [markers, setMarkers] = useState(markersCache.data)
  const authScopeRef = useRef(`${isAuthenticated}|${currentOrganizationKey}`)

  useEffect(() => {
    const scope = `${isAuthenticated}|${currentOrganizationKey}`

    if (authScopeRef.current !== scope) {
      authScopeRef.current = scope
      markersCache = { signature: null, data: [] }
      setMarkers([])
    }

    const devicesFilters = structuredClone(filters)
    delete devicesFilters.isAlarm

    const signature = JSON.stringify({ devicesFilters, scope })
    if (markersCache.signature === signature) {
      setMarkers(markersCache.data)
      return
    }

    useFetchMarkers({
      filters: devicesFilters
    }).then(({ data }) => {
      markersCache = { signature, data }
      setMarkers(data)
    })
  }, [filters, currentOrganizationKey, isAuthenticated])

  const mapContainerStyle = {
    width: '100%',
    minHeight: '100%',
    height: 'calc(100vh - 150px)'
  }

  return (
    <APIProvider
      apiKey={GOOGLE_MAPS_API_KEY}
      language="it"
      region="IT"
    >
      <Map
        id="frontpage-map"
        mapId="frontpage-map"
        style={mapContainerStyle}
        defaultZoom={zoom}
        defaultCenter={center}
        gestureHandling='greedy'
        zoomControl
        mapTypeControl
        mapTypeControlOptions={{ position: 3.0 }}
        disableDefaultUI
      >
        <Markers devices={markers} />
      </Map>
    </APIProvider>
  )
}

export default memo(FrontMap)
